import React, { useState } from 'react'
import { CustomDisabledTextfield, CustomTextField } from '../../Components/custom-textfield/CustomTextField';
import CustomCheckBox from '../../Components/custom-checkbox/CustomCheckbox';
import { AccordionDetails, Grid } from '@mui/material';
import { t } from 'i18next';

function PosRequestInfo({ objectDto, lang, validate, setObjectDto }) {
    const [emailNot, setEmailNot] = useState(objectDto.emailNotChecked === 1 ? true : false)
    const [email, setEmail] = useState(objectDto.email === undefined || objectDto.email === null ? '' : objectDto.email);
    return (
        <>
            <AccordionDetails>
                <Grid container spacing={1.5} paddingLeft={"10px"} paddingRight={"10px"}>
                    <Grid item xs={12} sm={4}>
                        <CustomDisabledTextfield variant="outlined" label={lang('policynumber')} size="small" fullWidth disabled
                            value={objectDto["policyNo"] !== undefined ? objectDto["policyNo"] : ""} />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <CustomDisabledTextfield variant="outlined" size="small" label={lang('idnumber')} fullWidth disabled
                            value={objectDto["idNumber"] !== undefined ? objectDto["idNumber"] : ""} />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <CustomDisabledTextfield variant="outlined" label={lang('phone')} size="small" fullWidth disabled
                            value={objectDto["phone"] !== undefined ? objectDto["phone"] : ""} />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        {
                            objectDto.saved === 1 ? (
                                <CustomDisabledTextfield variant="outlined" label={lang('email')} size="small" fullWidth disabled
                                    value={email} />
                            ) : (
                                <CustomTextField variant="outlined" label={lang('email')} required value={email} id="email" name="email" size="small"
                                    fullWidth focusColor="#c4960c"
                                    disabled={emailNot || objectDto.saved === 1}
                                    helperText={validate === true && (email === '' || email === undefined) && emailNot === false ? t('NotEmptyjavalangString') : ""}
                                    onChange={(e) => {
                                        setEmail(e.target.value);
                                        setObjectDto({ ...objectDto, email: e.target.value })
                                    }} />
                            )
                        }
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <CustomDisabledTextfield variant="outlined" label={lang('policyowner')} size="small" fullWidth disabled
                            value={objectDto["poName"] !== undefined ? objectDto["poName"] : ""} />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <CustomDisabledTextfield variant="outlined" label={lang('policylife')} size="small" fullWidth disabled
                            value={objectDto["laName"] !== undefined ? objectDto["laName"] : ""} />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <CustomCheckBox className="iCheck-checkbox" id="emailNot" value={emailNot} title={lang('emailnot')} disabled={objectDto.saved === 1}
                            onChange={(e) => {
                                setObjectDto({ ...objectDto, emailNotChecked: e.target.checked === true ? 1 : 0 })
                                setEmailNot(e.target.checked);
                            }}
                        />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </>
    )
}

export default PosRequestInfo